// extracted by mini-css-extract-plugin
module.exports = {"tabsMenu":"OperatorManagement_tabsMenu__1p8t9","badge":"OperatorManagement_badge__w7b04"};